import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";
import { get } from "lodash";

export const VideoProgressService = {
  addVideoProgress,
  updateVideoProgress,
  getVideoProgress,
  getTopicProgress,
  cleanOlderVideoProgress,
};

async function addVideoProgress(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/video-progress/add`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function updateVideoProgress(data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/video-progress/update`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getVideoProgress(user_id, video_id) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/video-progress/user/${user_id}/video/${video_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getTopicProgress(topic_id, user_id) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/video-progress/topic/${topic_id}/user/${user_id}/progress`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function cleanOlderVideoProgress(user_id) {
  const requestOptions = {
    method: "DELETE",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/video-progress/user/${user_id}/cleanup`,
    requestOptions
  );

  return APIHandler.handleResponse(response);
}
